import React from 'react';

const AccountRegistrationContext = React.createContext();

export default AccountRegistrationContext;
